


















































import {
  Home,
  Users,
  User,
  BarChart2,
  Settings,
  Bell,
  ChevronDown,
  Menu,
  X,
  ClipboardList,
  MessageCircle,
  ChevronRight,
  ShieldCheck,
  ExternalLink,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../app/store";
import { useState,useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import { useNotificationStore } from "../app/notificationStore";
import userIcon from "../assets/user.png";
import { LogOut } from "lucide-react";
import { useLocation } from "react-router-dom";
import ChatDrawer from "../pages/chat/ChatDrawer";
import { getProfileApi, getChatUnreadApi } from "../app/api";  
import CreatePayrollInfoModal from "../pages/payroll/components/CreatePayrollInfoModal";
const IMAGE_BASE_URL = "https://demouptask.visiontrek.io/";
 
export default function FilloNavbar() {
 
  const location = useLocation();
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);



  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "dark"
  );
 
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);
 
 
 
  const [profilePic, setProfilePic] = useState(null);
  const removeNotification = useNotificationStore(
    (s) => s.removeNotification
  );
 
 
  const [notifOpen, setNotifOpen] = useState(false);
  const notifRef = useRef(null);
  const navigate = useNavigate();
  const notifications = useNotificationStore((s) => s.notifications);
 
  const unreadCount = useNotificationStore((s) => s.unreadCount);
  const clearUnread = useNotificationStore((s) => s.clearUnread);
  const chatUnreadCount = useNotificationStore((s) => s.chatUnreadCount);
  const setChatUnreadCount = useNotificationStore((s) => s.setChatUnreadCount);
 
  const [chatOpen, setChatOpen] = useState(false);
  const [isPayrollModalOpen, setIsPayrollModalOpen] = useState(false);


  useEffect(() => {
    const chatData = localStorage.getItem("openChatFromNotification");
  
    if (chatData) {
      const parsed = JSON.parse(chatData);
  
      // 🔥 open chat drawer
      setChatOpen(true);
  
      // 🔥 store selected user globally
      window.__OPEN_CHAT_USER_ID__ = parsed.userId;
  
      // clear storage
      localStorage.removeItem("openChatFromNotification");
    }
  }, []);
 
  const { logout } = useAuth();
  const [open, setOpen] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
 
 
const user = JSON.parse(localStorage.getItem("user"));

const hasExperience = Number(user?.experience) >= 2;
const isHR = Number(user?.role_id) === 2;

const canSeeAllProjects =
  Number(user?.experience) >= 2 || isHR;
 
 
 
const username = `${user.first_name || ""} ${user.last_name || ""}`.trim();
  const menu = [
    { label: "Dashboard", icon: Home, path: "/" },
 
 
    ...(isHR
      ? [
          {
            label: "Employees",
            icon: Users,
            children: [
              { label: "Create User", path: "/employees/create" },
              { label: "Employees", path: "/employees" },
              { label: "Departments", path: "/departments" },
              { label: "Ex Employees", path: "/employees/ex" },
            ],
          },
        ]
      : []),
 
    {
      label: "Attendance",
      icon: BarChart2,
      children: [
 
       
        { label: "My Attendance", path: "/attendance/me" },
     
 
         // only HR
    ...(isHR
      ? [
          { label: "All Attendance", path: "/attendance/all" },
          { label: "Monthly", path: "/attendance/monthly" },
        ]
      : []),
      ],
    },
 
    /* ================= TASKS ================= */
    {
      label: "Tasks",
      icon: ClipboardList,
      children: [
        { label: "Create Task", path: "/tasks/my" },
        { label: "All Tasks", path: "/tasks/all" },
        { label: "Team Tasks", path: "/tasks/team" },
        { label: "Assigned Tasks", path: "/tasks/assigned" },
        { label: "Monthly Tasks", path: "/tasks/monthly" },
      ],
    },
 
    // ====================projects=====================


    {
      label: "Projects",
      icon: ClipboardList,
      children: [
        { label: "Create Project", path: "/projects/create" },
    
        ...(canSeeAllProjects
          ? [{ label: "All Projects", path: "/projects/all" }]
          : []),
    
        { label: "My Projects", path: "/projects/my" },
      ],
    },



 
    {
      label: "Documents",
      icon: ClipboardList,
      children: [
        { label: "Upload Documents", path: "upload/documents" },
     
 
        ...(isHR
          ? [
            { label: "All Documents", path: "/documents/all" },
            ]
          : []),
      ],
    },


    // {
    //   label: "Gallery",
    //   icon: ClipboardList,
    //   children: [
    //     { label: "View Gallery", path: "/gallery" },
     
 
        
    //   ],
    // },
 


    {
      label: "Gallery",
      icon: ClipboardList,
      path: "/gallery",
    },

    {
      label: "Grievance",
      icon: MessageCircle,
      path: "/grievance",
    },
    // {
    //   label: "Our Policy",
    //   icon: ShieldCheck,
    //   path: "/visiontrek/policy",
    // },



    {
      label: "Policies",
      icon: ShieldCheck,
      children: [
        // { label: "Leave Policy", path: "/leaves/policy" },
        { 
          label: "Leave Policy",
          path: "/Leave policy (2026) 1.pdf",
          external: true,
          icon: ExternalLink
        },
        { 
          label: "Increment Policy",
          path: "/Increment.pdf",
          external: true,
          icon: ExternalLink
        },
      ],
    },

 
    ...(isHR
      ? [
        {
          label: "Expenses",
          icon: Settings,
          children: [
            { label: "Add Expense", path: "/expenses/add" },
            { label: "Expense List", path: "/expenses" },
            { label: "Wallet", path: "/expenses/wallet" },
            { label: "Categories", path: "/expenses/categories" },
          ],
        },
   
        ]
      : []),
 
    {
      label: "Leaves",
      icon: Settings,
      children: [
        { label: "Apply Leave", path: "/leaves/apply" },
        { label: "My Leaves", path: "/leaves/me" },
       
 
        ...(isHR
          ? [
            { label: "Pending", path: "/leaves/pending" },
            { label: "Leave Report", path: "/leaves/report" },
            ]
          : []),
 
        { label: "Leave Policy", path: "/leaves/policy" },
        { label: "Holidays", path: "/leaves/holidays" },
      ],
    },
 
 
    ...(isHR
      ? [
        {
          label: "Inventory",
          icon: Settings,
          children: [
            // { label: "Inventory Type", path: "/inventory" },
            { label: "All Items", path: "/inventory/all" },
            { label: "Assigned Items", path: "/inventory/assign" },
            { label: "Add Item Type", path: "/inventory/add" },
           
          ],
        },
   
        ]
      : []),
    ...(isHR
      ? [
        {
          label: "Payroll",
          icon: ClipboardList,
          children: [
            { label: "Payroll Overview", path: "/payroll" },
            { label: "Monthly Records", path: "/payroll/records" },
            { label: "Salary Details", path: "/payroll/salaries" },
            { label: "Increment Section", path: "/payroll/increment" },
            { label: "Create User Info", onClick: () => setIsPayrollModalOpen(true) },
            { label: "Payslips", path: "/payroll/payslips" },
          ],
        },
      ]
      : []),
    ];
 


  // 👇 Pick what you want visible

  const visibleLabels = ["Dashboard", "Attendance", "Tasks", "Projects", "Leaves", "Payroll"];

  const desktopVisibleMenu = menu.filter((item) =>
    visibleLabels.includes(item.label)
  );

  const desktopMoreMenu = menu.filter(
    (item) => !visibleLabels.includes(item.label)
  );


 
  const desktopMenu = [
    ...desktopVisibleMenu,
    ...(desktopMoreMenu.length > 0
      ? [
      

          {
            label: "More",
            isMore: true,
            children: desktopMoreMenu,
          }
        ]
      : []),
  ];
 
 
 
  const scrollToContent = () => {
    setMobileOpen(false);
    setTimeout(() => {
      const el = document.getElementById("page-content");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);
  };
 
 
 
  useEffect(() => {
    function handleClickOutside(e) {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
    }
 
    if (notifOpen) {
      document.addEventListener("click", handleClickOutside);
    }
 
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [notifOpen]);
 
 
 
 
 
  useEffect(() => {
    const loadProfile = async () => {
      const res = await getProfileApi();
      if (res?.success) {
        setProfilePic(res.data.profile_pic);
      }
    };
   
    const loadUnreadChats = async () => {
      try {
        const res = await getChatUnreadApi();
        if (res?.success) setChatUnreadCount(res.count);
      } catch(e){}
    };
 
    loadProfile();
    loadUnreadChats();
  }, []);
 




  useEffect(() => {
    function handleClickOutside(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    }
  
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);





  const formatNotifTime = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric", // optional but better
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getRelativeNotifTime = (date) => {
    if (!date) return "";
    const now = new Date();
    const d = new Date(date);
    const diffInSeconds = Math.floor((now - d) / 1000);

    if (diffInSeconds < 60) return "Now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    
    if (now.toDateString() === d.toDateString()) return "Today";
    
    const diffInDays = Math.floor(diffInSeconds / 86400);
    if (diffInDays === 1) return "1 day ago";
    return `${diffInDays} days ago`;
  };





 
  return (
    <>
      {/* ================= TOP NAVBAR ================= */}
      <div
        className="
        h-16 px-4 sm:px-6 flex items-center justify-between
        bg-[#291857]
        shadow-lg shadow-black/40
        backdrop-blur-xl
        border-b border-white/10
        text-white
        relative z-50
      "
      >
        {/* LEFT */}
        <div className="flex items-center gap-4">
          <button className="lg:hidden" onClick={() => setMobileOpen(true)}>
            <Menu size={22} />
          </button>
 
       
        </div>
 
        {/* CENTER (DESKTOP MENU) */}
        <div className="hidden lg:flex gap-6 text-[13px] relative font-bold">
          {desktopMenu.map((item, i) => {
            const Icon = item.icon;
            const isActive = item.path
            ? location.pathname === item.path
            : item.children?.some((sub) =>
                location.pathname.startsWith(sub.path)
              );
            return (
              <div
                key={i}
                className="relative"
                onMouseEnter={() => setOpen(i)}
                onMouseLeave={() => setOpen(null)}
              >
          

{/* <div className="flex items-center gap-0.5 cursor-pointer hover:text-purple-200 py-1"> */}




<div
  className={`
    flex items-center gap-1 cursor-pointer py-1 px-2 rounded-md transition
    ${isActive ? "bg-white/20 text-white" : "hover:bg-white/10"}
  `}
>
  {/* {item.path ? (
    <Link to={item.path} className="flex items-center gap-2">
      {item.icon && <Icon size={14} />}
      {item.label}
    </Link>
  ) : ( */}

{item.path ? (
  item.external ? (
    <a
      href={item.path}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2"
    >
      {item.icon && <Icon size={14} />}
      {item.label}
    </a>
  ) : (
    <Link to={item.path} className="flex items-center gap-2">
      {item.icon && <Icon size={14} />}
      {item.label}
    </Link>
  )
) : (
    <>
      {item.icon && <Icon size={14} />}
      {item.label}
      <ChevronDown size={14} />
    </>
  )}
</div>
 
                {item.children && open === i && (
                  <div
                    className={`
                    absolute left-0 top-[100%] z-50
                    bg-[#3a2a72]/95
                    backdrop-blur-sm
                    border border-white/10
                    rounded-xl shadow-lg
                    py-2 whitespace-nowrap
                    `}
                    style={{ minWidth: item.isMore ? '180px' : '144px' }}
                  >
                    <div className="absolute -top-2 left-0 w-full h-2" />
                    {item.isMore ? (
                        item.children.map((moreItem, idx) => {
                            const MoreIcon = moreItem.icon;
                            const content = (
                                <div className="flex items-center gap-2 w-full">
                                    {MoreIcon && <MoreIcon size={14} />}
                                    {moreItem.label}
                                    {moreItem.children && <ChevronRight size={14} className="ml-auto" />}
                                </div>
                            );
                            return (
                                <div
                                    key={idx}
                                    className="relative group px-4 py-2 hover:bg-[#4b3a8a] cursor-pointer"
                                >
                                    {moreItem.path ? (
                                        moreItem.external ? (
                                            <a 
                                                href={moreItem.path} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="block w-full"
                                            >
                                                {content}
                                            </a>
                                        ) : (
                                            <Link to={moreItem.path} className="block w-full">{content}</Link>
                                        )
                                    ) : (
                                        <div className="block w-full">{content}</div>
                                    )}
 
                                    {moreItem.children && (
                                        <div className="absolute left-[99%] top-0 hidden group-hover:block bg-[#3a2a72]/95 backdrop-blur-md border border-white/10 rounded-xl shadow-lg py-2 min-w-[144px]">
                                            <div className="absolute -left-2 top-0 w-2 h-full" />
                                            {moreItem.children.map((sub, j) => {
                                                const SubIcon = sub.icon;
                                                const subContent = (
                                                    <div className="flex items-center gap-2">
                                                        {SubIcon && <SubIcon size={14} />}
                                                        {sub.label}
                                                    </div>
                                                );
                                                return sub.external ? (
                                                    <a
                                                        key={j}
                                                        href={sub.path}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="block px-4 py-2 hover:bg-[#4b3a8a]"
                                                    >
                                                        {subContent}
                                                    </a>
                                                ) : (
                                                    <Link
                                                        key={j}
                                                        to={sub.path}
                                                        className="block px-4 py-2 hover:bg-[#4b3a8a]"
                                                    >
                                                        {subContent}
                                                    </Link>
                                                )
                                            })}


</div>
                                    )}
                                </div>
                            );
                        })
                    ) : (
//                         item.children.map((sub, j) => (
                          
//                             <Link
//   key={j}
//   to={sub.path}
//   className={`
//     block px-4 py-2
//     ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
//   `}
// >
//                                 {sub.label}
//                             </Link>
//                         ))





item.children.map((sub, j) => {
  const SubIcon = sub.icon;
  const subContent = (
    <div className="flex items-center gap-2">
      {SubIcon && <SubIcon size={14} />}
      {sub.label}
    </div>
  );
  return (
    <div key={j}>
      {sub.onClick ? (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpen(null);
            sub.onClick();
          }}
          className="w-full text-left block px-4 py-2 hover:bg-[#4b3a8a] transition"
        >
          {subContent}
        </button>
      ) : sub.external ? (
        <a
          href={sub.path}
          target="_blank"
          rel="noopener noreferrer"
          className="block px-4 py-2 hover:bg-[#4b3a8a]"
        >
          {subContent}
        </a>
      ) : (
        <Link
          to={sub.path}
          className={`
            block px-4 py-2
            ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
          `}
        >
          {subContent}
        </Link>
      )}
    </div>
  )
})
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
 
        {/* RIGHT */}
        <div className="flex items-center gap-4 text-sm ">
<div className="relative mt-2 gap-6">
  <button
      onClick={() => setChatOpen(true)}
      className=" mr-2 rounded-full hover:bg-white/10 transition text-white relative"
    >
      <MessageCircle size={20} />
      {chatUnreadCount > 0 && (
        <span className="
        absolute -top-2 -right-2
        bg-red-500 text-white
        text-[10px] font-bold
        w-5 h-5 rounded-full
        flex items-center justify-center
         ">
          {chatUnreadCount}
        </span>
      )}
  </button>
 
  <button
      onClick={(e) => {  
      e.stopPropagation();        // 🔥 THIS LINE FIXES IT
      setNotifOpen((o) => !o);
      clearUnread();
    }}
    className="relative"
  >
 
  <Bell
  size={20}
  className={unreadCount > 0 ? "animate-bell" : ""}
/>
 
    {unreadCount > 0 && (
      <span
        className="
          absolute -top-2 -right-2
          bg-red-500 text-white
          text-[10px] font-bold
          w-5 h-5 rounded-full
          flex items-center justify-center
        "
      >
        {unreadCount}
      </span>
    )}
  </button>
 
 
</div>


 <div className="relative w-7 h-7 " ref={profileRef}>
  <button
    onClick={(e) => {
      e.stopPropagation();
      setProfileOpen((prev) => !prev);
    }}
    className="w-8 h-8 rounded-full overflow-hidden bg-white/20"
  >
    {profilePic ? (
      <img
        src={`${IMAGE_BASE_URL}${profilePic}`}
        className="w-8 h-8 object-cover "
        alt="Profile"
        />
    ) : (
      <User size={14} className=" ml-2" />
    )}
  </button>

  {profileOpen && (
      
<div className="absolute right-0 mt-2 w-34 bg-[#3a2a72] border border-white/10 rounded-lg shadow-lg z-50">

<Link
  to="/profile"
  onClick={() => setProfileOpen(false)}
  className="flex items-center gap-2 px-4 py-2 hover:bg-[#4b3a8a] text-white"
>
  <User size={16} className="text-white" />
  Profile
</Link>

<button
  onClick={() => {
    setProfileOpen(false);
    logout();
  }}
  className="w-full flex items-center gap-2 px-4 py-2 text-left hover:bg-red-500/30 text-white"
>
  <LogOut size={16} className="text-white" />
  Logout
</button>

</div>


  )}
</div>

        </div>
      </div>
 
      {/* ================= MOBILE SIDEBAR ================= */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileOpen(false)}
          />
 
          <div
            className="
            absolute left-0 top-0 h-full w-72
            bg-[#291857]
            shadow-2xl shadow-black/50
            p-5
            flex flex-col gap-4
            text-white
            overflow-y-auto
          "
          >
            <div className="flex justify-between items-center mb-4">
              <span className="font-semibold text-lg">UPTASK</span>
              <button onClick={() => setMobileOpen(false)}>
                <X size={22} />
              </button>
            </div>
 
            {menu.map((item, i) => {
              const Icon = item.icon;
 
              return (
                <div key={i}>
                  {item.path ? (
                    item.external ? (
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setMobileOpen(false)}
                        className="flex items-center gap-3 py-2"
                      >
                        <Icon size={18} />
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.path}
                        onClick={() => setMobileOpen(false)}
                        className="flex items-center gap-3 py-2"
                      >
                        <Icon size={18} />
                        {item.label}
                      </Link>
                    )
                  ) : (
                    <>
                      <div className="flex items-center gap-3 py-2 opacity-80">
                        <Icon size={18} />
                        {item.label}
                      </div>
 
                      <div className="ml-7 flex flex-col text-sm opacity-70">
                        {item.children.map((sub, j) => {
                          const SubIcon = sub.icon;
                          const subContent = (
                            <div className="flex items-center gap-3">
                              {SubIcon && <SubIcon size={18} />}
                              {sub.label}
                            </div>
                          );
                          if (sub.onClick) {
                            return (
                              <button
                                key={j}
                                onClick={() => {
                                  setMobileOpen(false);
                                  sub.onClick();
                                }}
                                className="py-1 text-left w-full"
                              >
                                {subContent}
                              </button>
                            );
                          }

                          return sub.external ? (
                            <a
                              key={j}
                              href={sub.path}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => setMobileOpen(false)}
                              className="py-1"
                            >
                              {subContent}
                            </a>
                          ) : (
                            <Link
                              key={j}
                              to={sub.path}
                              onClick={scrollToContent}
                              className="py-1"
                            >
                              {subContent}
                            </Link>
                          )
                        })}
                      </div>
                    </>
                  )}
                </div>
              );
            })}
 

 
            <div className="mt-auto pt-4 border-t border-white/10">
 
 
 
              <button
                onClick={logout}
                className="w-full bg-red-500 py-2 rounded"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
 
 
 
 
 
 
 
 
 
 
 
      {/* ================= NOTIFICATION DRAWER ================= */}
{/* ================= NOTIFICATION DRAWER ================= */}
 
<div
  className={`
  fixed top-0 right-0 h-full w-[400px] max-w-[95vw]
  bg-[#2A1D55]/95
  supports-[backdrop-filter]:bg-white/10
  backdrop-blur-xl
  border-l border-white/20
  shadow-[0_20px_60px_rgba(0,0,0,0.4)]
  z-[60]
  transform transition-all duration-500 ease-outout
    ${notifOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}
  `}
>
 
  {/* HEADER */}
  <div className="flex justify-between items-center px-5 py-4 border-b border-white/20 backdrop-blur-md bg-[#2A1D55]">
 
    <span className="text-lg font-semibold text-white tracking-wide ">
      Notifications
    </span>
 
    <button
      onClick={() => setNotifOpen(false)}
      className="p-1 rounded-lg text-white/70 hover:text-red-400 hover:bg-white/10 transition"
    >
      <X size={20} />
    </button>
 
  </div>
 
 
  {/* CLEAR ALL */}
  {notifications.length > 0 && (
    <div className="flex justify-end px-5 mt-2 ">
      <button
        onClick={() => useNotificationStore.getState().clearAll()}
        className="
          text-xs font-semibold
          text-red-500 hover:text-red-400
          transition
        "
      >
        Clear All
      </button>
    </div>
  )}
 
 
  {/* BODY */}
  {notifications.length === 0 ? (
    <div className="flex items-center justify-center h-[70%] text-white/70 text-sm">
      No notifications
    </div>
  ) : (
    <ul className="overflow-y-auto h-[calc(100%-120px)] p-4 space-y-3">
 
      {notifications.map((n) => (

      

//         <li
//         key={n.id}
//         className="
//           relative flex gap-3 p-3
//           bg-white/10 backdrop-blur-md
//           border border-white/10
//           rounded-xl
//           hover:bg-white/20
//           transition-all duration-200
//           shadow-md
//           group
//         "
// >

        <li
        key={n.id}
        className="
    relative flex gap-3 p-3 bg-[#1e1e2f]/80
        border border-white/10 rounded-xl hover:bg-[#2a2a40]
       transition-all duration-200 shadow-md group backdrop-blur-sm
        "
>

        {/* CLOSE BUTTON */}
<button
          onClick={(e) => {
            e.stopPropagation();
            removeNotification(n.id);
          }}
          className="
            absolute top-2 right-2
            opacity-0 group-hover:opacity-100
            transition
            text-white hover:text-red-400
          "
>
<X size={14} />
</button>

        {/* AVATAR */}
<div className="w-9 h-9 rounded-full overflow-hidden bg-white/20 border border-white/20 shrink-0">


  <img
    src={
      n.sender_profile_pic
        ? `${IMAGE_BASE_URL}${n.sender_profile_pic}`
        : n.userdata?.profile_pic
        ? `${IMAGE_BASE_URL}${n.userdata.profile_pic}`
        : userIcon
    }
    className="w-9 h-9 object-cover"
    alt="User"
    onError={(e) => (e.target.src = userIcon)}
  />
</div>

{/* RELATIVE TIME IN TOP RIGHT */}
<div className="absolute top-1 right-3 text-[8px] font-bold text-white/50 uppercase tracking-wider group-hover:opacity-0 transition-opacity">
  {getRelativeNotifTime(n.created_at)}
</div>
<div
          className="flex-1 cursor-pointer"
       




          onClick={() => {
            removeNotification(n.id);
            setNotifOpen(false);
          
            const typeKey = (n.type || "").toUpperCase();
          
            if (typeKey === "LEAVE") {
              navigate("/leaves/pending");
          
            } else if (typeKey === "CHAT") {
              setChatOpen(true);

            } else if (typeKey === "LATE PUNCH IN") {
                navigate("/attendance/all");

              } else if (typeKey === "EXTRA BREAK") {
                navigate("/attendance/all");
              } else if (typeKey === "EARLY PUNCH OUT") {
                navigate("/attendance/all");


              } else if (typeKey === "TASK ASSIGNED") {
                navigate("/tasks/assigned");
                
              } else if (typeKey === "GRIEVANCE_UPDATE") {
                navigate("/grievance");



              } else if (typeKey === "TASK COMMENT") {
                navigate("/tasks/all");
              } else if (typeKey === "TASK UPDATED") {
                navigate("/tasks/all");
              } else if (typeKey === "TASK DUE TODAY") {
                navigate("/tasks/all");
              } else if (typeKey === "DUE DATE CHANGED") {
                navigate("/tasks/all");






          
            } else if (
              typeKey.includes("POST") || 
              typeKey.includes("FEED")
            ) {
              navigate("/", { state: { tab: "posts" } });
          
            } else {
              // ✅ MAIN FIX (your requirement)
              navigate(n.redirectTo || "/");
            }
          }}
>


<div className="text-sm font-medium text-white leading-snug">
              {n.message}
            </div>
 
            <div className="flex items-center gap-2 mt-1">
 
              <span className="
                text-[10px]
                px-2 py-[2px]
                rounded-sm shadow-lg
                bg-purple-500/30
                text-purple-200
                font-semibold
              ">
                {n.type.toUpperCase()}
              </span>
 
              {n.leaveType && (
                <span className="text-[10px] text-white/60">
                  {n.leaveType}
                </span>
              )}
 




 <span className="text-[10px] text-white/70 ml-auto mb-[-14px] font-medium">
                {formatNotifTime(n.created_at)}
              </span>

              
            </div>
 
          </div>
 
</li>
      ))}
    </ul>
  )}
 
</div>
 
{chatOpen && <ChatDrawer onClose={() => setChatOpen(false)} />}
      <CreatePayrollInfoModal 
        isOpen={isPayrollModalOpen} 
        onClose={() => setIsPayrollModalOpen(false)} 
        onSuccess={() => window.location.reload()}
      />
      
      {/* BACKDROP OVERLAY */}
{notifOpen && (
  <div
    className="
      fixed inset-0
      bg-black/50
      backdrop-blur-sm
      z-50
      transition-opacity
    "
    onClick={() => setNotifOpen(false)}
  />
)}
    </>
  );
}
 








































// import {
//   Home,
//   Users,
//   User,
//   BarChart2,
//   Settings,
//   Bell,
//   ChevronDown,
//   Menu,
//   X,
//   ClipboardList,
//   MessageCircle,
//   ChevronRight,
//   ShieldCheck,
//   ExternalLink,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../app/store";
// import { useState,useEffect,useRef } from "react";
// import { Link } from "react-router-dom";
// import { useNotificationStore } from "../app/notificationStore";
// import userIcon from "../assets/user.png";
// import { LogOut } from "lucide-react";
// import { useLocation } from "react-router-dom";
// import ChatDrawer from "../pages/chat/ChatDrawer";
// import { getProfileApi, getChatUnreadApi } from "../app/api";  
// import CreatePayrollInfoModal from "../pages/payroll/components/CreatePayrollInfoModal";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
 
// export default function FilloNavbar() {
 
//   const location = useLocation();
//   const [profileOpen, setProfileOpen] = useState(false);
//   const profileRef = useRef(null);



//   const [theme, setTheme] = useState(
//     localStorage.getItem("theme") || "dark"
//   );
 
//   useEffect(() => {
//     document.documentElement.classList.toggle("dark", theme === "dark");
//     localStorage.setItem("theme", theme);
//   }, [theme]);
 
 
 
//   const [profilePic, setProfilePic] = useState(null);
//   const removeNotification = useNotificationStore(
//     (s) => s.removeNotification
//   );
 
 
//   const [notifOpen, setNotifOpen] = useState(false);
//   const notifRef = useRef(null);
//   const navigate = useNavigate();
//   const notifications = useNotificationStore((s) => s.notifications);
 
//   const unreadCount = useNotificationStore((s) => s.unreadCount);
//   const clearUnread = useNotificationStore((s) => s.clearUnread);
//   const chatUnreadCount = useNotificationStore((s) => s.chatUnreadCount);
//   const setChatUnreadCount = useNotificationStore((s) => s.setChatUnreadCount);
 
//   const [chatOpen, setChatOpen] = useState(false);
//   const [isPayrollModalOpen, setIsPayrollModalOpen] = useState(false);


//   useEffect(() => {
//     const chatData = localStorage.getItem("openChatFromNotification");
  
//     if (chatData) {
//       const parsed = JSON.parse(chatData);
  
//       // 🔥 open chat drawer
//       setChatOpen(true);
  
//       // 🔥 store selected user globally
//       window.__OPEN_CHAT_USER_ID__ = parsed.userId;
  
//       // clear storage
//       localStorage.removeItem("openChatFromNotification");
//     }
//   }, []);
 
//   const { logout } = useAuth();
//   const [open, setOpen] = useState(null);
//   const [mobileOpen, setMobileOpen] = useState(false);
 
 
// const user = JSON.parse(localStorage.getItem("user"));

// const hasExperience = Number(user?.experience) >= 2;
// const isHR = Number(user?.role_id) === 2;

// const canSeeAllProjects =
//   Number(user?.experience) >= 2 || isHR;
 
 
 
// const username = `${user.first_name || ""} ${user.last_name || ""}`.trim();
//   const menu = [
//     { label: "Dashboard", icon: Home, path: "/" },
 
 
//     ...(isHR
//       ? [
//           {
//             label: "Employees",
//             icon: Users,
//             children: [
//               { label: "Create User", path: "/employees/create" },
//               { label: "Employees", path: "/employees" },
//               { label: "Departments", path: "/departments" },
//               { label: "Ex Employees", path: "/employees/ex" },
//             ],
//           },
//         ]
//       : []),
 
//     {
//       label: "Attendance",
//       icon: BarChart2,
//       children: [
 
       
//         { label: "My Attendance", path: "/attendance/me" },
     
 
//          // only HR
//     ...(isHR
//       ? [
//           { label: "All Attendance", path: "/attendance/all" },
//           { label: "Monthly", path: "/attendance/monthly" },
//         ]
//       : []),
//       ],
//     },
 
//     /* ================= TASKS ================= */
//     {
//       label: "Tasks",
//       icon: ClipboardList,
//       children: [
//         { label: "Create Task", path: "/tasks/my" },
//         { label: "All Tasks", path: "/tasks/all" },
//         { label: "Team Tasks", path: "/tasks/team" },
//         { label: "Assigned Tasks", path: "/tasks/assigned" },
//         ...(isHR ? [{ label: "Monthly Tasks", path: "/tasks/monthly" }] : []),
//       ],
//     },
 
//     // ====================projects=====================


//     {
//       label: "Projects",
//       icon: ClipboardList,
//       children: [
//         { label: "Create Project", path: "/projects/create" },
    
//         ...(canSeeAllProjects
//           ? [{ label: "All Projects", path: "/projects/all" }]
//           : []),
    
//         { label: "My Projects", path: "/projects/my" },
//       ],
//     },



 
//     {
//       label: "Documents",
//       icon: ClipboardList,
//       children: [
//         { label: "Upload Documents", path: "upload/documents" },
     
 
//         ...(isHR
//           ? [
//             { label: "All Documents", path: "/documents/all" },
//             ]
//           : []),
//       ],
//     },


//     // {
//     //   label: "Gallery",
//     //   icon: ClipboardList,
//     //   children: [
//     //     { label: "View Gallery", path: "/gallery" },
     
 
        
//     //   ],
//     // },
 


//     {
//       label: "Gallery",
//       icon: ClipboardList,
//       path: "/gallery",
//     },

//     {
//       label: "Grievance",
//       icon: MessageCircle,
//       path: "/grievance",
//     },
//     // {
//     //   label: "Our Policy",
//     //   icon: ShieldCheck,
//     //   path: "/visiontrek/policy",
//     // },



//     {
//       label: "Policies",
//       icon: ShieldCheck,
//       children: [
//         // { label: "Leave Policy", path: "/leaves/policy" },
//         { 
//           label: "Leave Policy",
//           path: "/Leave policy (2026) 1.pdf",
//           external: true,
//           icon: ExternalLink
//         },
//         { 
//           label: "Increment Policy",
//           path: "/Increment.pdf",
//           external: true,
//           icon: ExternalLink
//         },
//       ],
//     },

 
//     ...(isHR
//       ? [
//         {
//           label: "Expenses",
//           icon: Settings,
//           children: [
//             { label: "Add Expense", path: "/expenses/add" },
//             { label: "Expense List", path: "/expenses" },
//             { label: "Wallet", path: "/expenses/wallet" },
//             { label: "Categories", path: "/expenses/categories" },
//           ],
//         },
   
//         ]
//       : []),
 
//     {
//       label: "Leaves",
//       icon: Settings,
//       children: [
//         { label: "Apply Leave", path: "/leaves/apply" },
//         { label: "My Leaves", path: "/leaves/me" },
       
 
//         ...(isHR
//           ? [
//             { label: "Pending", path: "/leaves/pending" },
//             { label: "Leave Report", path: "/leaves/report" },
//             ]
//           : []),
 
//         { label: "Leave Policy", path: "/leaves/policy" },
//         { label: "Holidays", path: "/leaves/holidays" },
//       ],
//     },
 
 
//     ...(isHR
//       ? [
//         {
//           label: "Inventory",
//           icon: Settings,
//           children: [
//             // { label: "Inventory Type", path: "/inventory" },
//             { label: "All Items", path: "/inventory/all" },
//             { label: "Assigned Items", path: "/inventory/assign" },
//             { label: "Add Item Type", path: "/inventory/add" },
           
//           ],
//         },
   
//         ]
//       : []),
//     ...(isHR
//       ? [
//         {
//           label: "Payroll",
//           icon: ClipboardList,
//           children: [
//             { label: "Payroll Overview", path: "/payroll" },
//             { label: "Monthly Records", path: "/payroll/records" },
//             { label: "Salary Details", path: "/payroll/salaries" },
//             { label: "Increment Section", path: "/payroll/increment" },
//             { label: "Create User Info", onClick: () => setIsPayrollModalOpen(true) },
//             { label: "Payslips", path: "/payroll/payslips" },
//           ],
//         },
//       ]
//       : []),
//     ];
 


//   // 👇 Pick what you want visible

//   const visibleLabels = ["Dashboard", "Attendance", "Tasks", "Projects", "Leaves", "Payroll"];

//   const desktopVisibleMenu = menu.filter((item) =>
//     visibleLabels.includes(item.label)
//   );

//   const desktopMoreMenu = menu.filter(
//     (item) => !visibleLabels.includes(item.label)
//   );


 
//   const desktopMenu = [
//     ...desktopVisibleMenu,
//     ...(desktopMoreMenu.length > 0
//       ? [
      

//           {
//             label: "More",
//             isMore: true,
//             children: desktopMoreMenu,
//           }
//         ]
//       : []),
//   ];
 
 
 
//   const scrollToContent = () => {
//     setMobileOpen(false);
//     setTimeout(() => {
//       const el = document.getElementById("page-content");
//       if (el) {
//         el.scrollIntoView({ behavior: "smooth", block: "start" });
//       }
//     }, 150);
//   };
 
 
 
//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (notifRef.current && !notifRef.current.contains(e.target)) {
//         setNotifOpen(false);
//       }
//     }
 
//     if (notifOpen) {
//       document.addEventListener("click", handleClickOutside);
//     }
 
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [notifOpen]);
 
 
 
 
 
//   useEffect(() => {
//     const loadProfile = async () => {
//       const res = await getProfileApi();
//       if (res?.success) {
//         setProfilePic(res.data.profile_pic);
//       }
//     };
   
//     const loadUnreadChats = async () => {
//       try {
//         const res = await getChatUnreadApi();
//         if (res?.success) setChatUnreadCount(res.count);
//       } catch(e){}
//     };
 
//     loadProfile();
//     loadUnreadChats();
//   }, []);
 




//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setProfileOpen(false);
//       }
//     }
  
//     document.addEventListener("click", handleClickOutside);
//     return () => document.removeEventListener("click", handleClickOutside);
//   }, []);





//   const formatNotifTime = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     return d.toLocaleString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric", // optional but better
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const getRelativeNotifTime = (date) => {
//     if (!date) return "";
//     const now = new Date();
//     const d = new Date(date);
//     const diffInSeconds = Math.floor((now - d) / 1000);

//     if (diffInSeconds < 60) return "Now";
//     if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    
//     if (now.toDateString() === d.toDateString()) return "Today";
    
//     const diffInDays = Math.floor(diffInSeconds / 86400);
//     if (diffInDays === 1) return "1 day ago";
//     return `${diffInDays} days ago`;
//   };





 
//   return (
//     <>
//       {/* ================= TOP NAVBAR ================= */}
//       <div
//         className="
//         h-16 px-4 sm:px-6 flex items-center justify-between
//         bg-[#291857]
//         shadow-lg shadow-black/40
//         backdrop-blur-xl
//         border-b border-white/10
//         text-white
//         relative z-50
//       "
//       >
//         {/* LEFT */}
//         <div className="flex items-center gap-4">
//           <button className="lg:hidden" onClick={() => setMobileOpen(true)}>
//             <Menu size={22} />
//           </button>
 
       
//         </div>
 
//         {/* CENTER (DESKTOP MENU) */}
//         <div className="hidden lg:flex gap-6 text-[13px] relative font-bold">
//           {desktopMenu.map((item, i) => {
//             const Icon = item.icon;
//             const isActive = item.path
//             ? location.pathname === item.path
//             : item.children?.some((sub) =>
//                 location.pathname.startsWith(sub.path)
//               );
//             return (
//               <div
//                 key={i}
//                 className="relative"
//                 onMouseEnter={() => setOpen(i)}
//                 onMouseLeave={() => setOpen(null)}
//               >
          

// {/* <div className="flex items-center gap-0.5 cursor-pointer hover:text-purple-200 py-1"> */}




// <div
//   className={`
//     flex items-center gap-1 cursor-pointer py-1 px-2 rounded-md transition
//     ${isActive ? "bg-white/20 text-white" : "hover:bg-white/10"}
//   `}
// >
//   {/* {item.path ? (
//     <Link to={item.path} className="flex items-center gap-2">
//       {item.icon && <Icon size={14} />}
//       {item.label}
//     </Link>
//   ) : ( */}

// {item.path ? (
//   item.external ? (
//     <a
//       href={item.path}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="flex items-center gap-2"
//     >
//       {item.icon && <Icon size={14} />}
//       {item.label}
//     </a>
//   ) : (
//     <Link to={item.path} className="flex items-center gap-2">
//       {item.icon && <Icon size={14} />}
//       {item.label}
//     </Link>
//   )
// ) : (
//     <>
//       {item.icon && <Icon size={14} />}
//       {item.label}
//       <ChevronDown size={14} />
//     </>
//   )}
// </div>
 
//                 {item.children && open === i && (
//                   <div
//                     className={`
//                     absolute left-0 top-[100%] z-50
//                     bg-[#3a2a72]/95
//                     backdrop-blur-sm
//                     border border-white/10
//                     rounded-xl shadow-lg
//                     py-2 whitespace-nowrap
//                     `}
//                     style={{ minWidth: item.isMore ? '180px' : '144px' }}
//                   >
//                     <div className="absolute -top-2 left-0 w-full h-2" />
//                     {item.isMore ? (
//                         item.children.map((moreItem, idx) => {
//                             const MoreIcon = moreItem.icon;
//                             const content = (
//                                 <div className="flex items-center gap-2 w-full">
//                                     {MoreIcon && <MoreIcon size={14} />}
//                                     {moreItem.label}
//                                     {moreItem.children && <ChevronRight size={14} className="ml-auto" />}
//                                 </div>
//                             );
//                             return (
//                                 <div
//                                     key={idx}
//                                     className="relative group px-4 py-2 hover:bg-[#4b3a8a] cursor-pointer"
//                                 >
//                                     {moreItem.path ? (
//                                         moreItem.external ? (
//                                             <a 
//                                                 href={moreItem.path} 
//                                                 target="_blank" 
//                                                 rel="noopener noreferrer" 
//                                                 className="block w-full"
//                                             >
//                                                 {content}
//                                             </a>
//                                         ) : (
//                                             <Link to={moreItem.path} className="block w-full">{content}</Link>
//                                         )
//                                     ) : (
//                                         <div className="block w-full">{content}</div>
//                                     )}
 
//                                     {moreItem.children && (
//                                         <div className="absolute left-[99%] top-0 hidden group-hover:block bg-[#3a2a72]/95 backdrop-blur-md border border-white/10 rounded-xl shadow-lg py-2 min-w-[144px]">
//                                             <div className="absolute -left-2 top-0 w-2 h-full" />
//                                             {moreItem.children.map((sub, j) => {
//                                                 const SubIcon = sub.icon;
//                                                 const subContent = (
//                                                     <div className="flex items-center gap-2">
//                                                         {SubIcon && <SubIcon size={14} />}
//                                                         {sub.label}
//                                                     </div>
//                                                 );
//                                                 return sub.external ? (
//                                                     <a
//                                                         key={j}
//                                                         href={sub.path}
//                                                         target="_blank"
//                                                         rel="noopener noreferrer"
//                                                         className="block px-4 py-2 hover:bg-[#4b3a8a]"
//                                                     >
//                                                         {subContent}
//                                                     </a>
//                                                 ) : (
//                                                     <Link
//                                                         key={j}
//                                                         to={sub.path}
//                                                         className="block px-4 py-2 hover:bg-[#4b3a8a]"
//                                                     >
//                                                         {subContent}
//                                                     </Link>
//                                                 )
//                                             })}


// </div>
//                                     )}
//                                 </div>
//                             );
//                         })
//                     ) : (
// //                         item.children.map((sub, j) => (
                          
// //                             <Link
// //   key={j}
// //   to={sub.path}
// //   className={`
// //     block px-4 py-2
// //     ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
// //   `}
// // >
// //                                 {sub.label}
// //                             </Link>
// //                         ))





// item.children.map((sub, j) => {
//   const SubIcon = sub.icon;
//   const subContent = (
//     <div className="flex items-center gap-2">
//       {SubIcon && <SubIcon size={14} />}
//       {sub.label}
//     </div>
//   );
//   return (
//     <div key={j}>
//       {sub.onClick ? (
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             setOpen(null);
//             sub.onClick();
//           }}
//           className="w-full text-left block px-4 py-2 hover:bg-[#4b3a8a] transition"
//         >
//           {subContent}
//         </button>
//       ) : sub.external ? (
//         <a
//           href={sub.path}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="block px-4 py-2 hover:bg-[#4b3a8a]"
//         >
//           {subContent}
//         </a>
//       ) : (
//         <Link
//           to={sub.path}
//           className={`
//             block px-4 py-2
//             ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
//           `}
//         >
//           {subContent}
//         </Link>
//       )}
//     </div>
//   )
// })
//                     )}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
 
//         {/* RIGHT */}
//         <div className="flex items-center gap-4 text-sm ">
// <div className="relative mt-2 gap-6">
//   <button
//       onClick={() => setChatOpen(true)}
//       className=" mr-2 rounded-full hover:bg-white/10 transition text-white relative"
//     >
//       <MessageCircle size={20} />
//       {chatUnreadCount > 0 && (
//         <span className="
//         absolute -top-2 -right-2
//         bg-red-500 text-white
//         text-[10px] font-bold
//         w-5 h-5 rounded-full
//         flex items-center justify-center
//          ">
//           {chatUnreadCount}
//         </span>
//       )}
//   </button>
 
//   <button
//       onClick={(e) => {  
//       e.stopPropagation();        // 🔥 THIS LINE FIXES IT
//       setNotifOpen((o) => !o);
//       clearUnread();
//     }}
//     className="relative"
//   >
 
//   <Bell
//   size={20}
//   className={unreadCount > 0 ? "animate-bell" : ""}
// />
 
//     {unreadCount > 0 && (
//       <span
//         className="
//           absolute -top-2 -right-2
//           bg-red-500 text-white
//           text-[10px] font-bold
//           w-5 h-5 rounded-full
//           flex items-center justify-center
//         "
//       >
//         {unreadCount}
//       </span>
//     )}
//   </button>
 
 
// </div>


//  <div className="relative w-7 h-7 " ref={profileRef}>
//   <button
//     onClick={(e) => {
//       e.stopPropagation();
//       setProfileOpen((prev) => !prev);
//     }}
//     className="w-8 h-8 rounded-full overflow-hidden bg-white/20"
//   >
//     {profilePic ? (
//       <img
//         src={`${IMAGE_BASE_URL}${profilePic}`}
//         className="w-8 h-8 object-cover "
//         alt="Profile"
//         />
//     ) : (
//       <User size={14} className=" ml-2" />
//     )}
//   </button>

//   {profileOpen && (
      
// <div className="absolute right-0 mt-2 w-34 bg-[#3a2a72] border border-white/10 rounded-lg shadow-lg z-50">

// <Link
//   to="/profile"
//   onClick={() => setProfileOpen(false)}
//   className="flex items-center gap-2 px-4 py-2 hover:bg-[#4b3a8a] text-white"
// >
//   <User size={16} className="text-white" />
//   Profile
// </Link>

// <button
//   onClick={() => {
//     setProfileOpen(false);
//     logout();
//   }}
//   className="w-full flex items-center gap-2 px-4 py-2 text-left hover:bg-red-500/30 text-white"
// >
//   <LogOut size={16} className="text-white" />
//   Logout
// </button>

// </div>


//   )}
// </div>

//         </div>
//       </div>
 
//       {/* ================= MOBILE SIDEBAR ================= */}
//       {mobileOpen && (
//         <div className="fixed inset-0 z-50 lg:hidden">
//           <div
//             className="absolute inset-0 bg-black/50"
//             onClick={() => setMobileOpen(false)}
//           />
 
//           <div
//             className="
//             absolute left-0 top-0 h-full w-72
//             bg-[#291857]
//             shadow-2xl shadow-black/50
//             p-5
//             flex flex-col gap-4
//             text-white
//             overflow-y-auto
//           "
//           >
//             <div className="flex justify-between items-center mb-4">
//               <span className="font-semibold text-lg">UPTASK</span>
//               <button onClick={() => setMobileOpen(false)}>
//                 <X size={22} />
//               </button>
//             </div>
 
//             {menu.map((item, i) => {
//               const Icon = item.icon;
 
//               return (
//                 <div key={i}>
//                   {item.path ? (
//                     item.external ? (
//                       <a
//                         href={item.path}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={() => setMobileOpen(false)}
//                         className="flex items-center gap-3 py-2"
//                       >
//                         <Icon size={18} />
//                         {item.label}
//                       </a>
//                     ) : (
//                       <Link
//                         to={item.path}
//                         onClick={() => setMobileOpen(false)}
//                         className="flex items-center gap-3 py-2"
//                       >
//                         <Icon size={18} />
//                         {item.label}
//                       </Link>
//                     )
//                   ) : (
//                     <>
//                       <div className="flex items-center gap-3 py-2 opacity-80">
//                         <Icon size={18} />
//                         {item.label}
//                       </div>
 
//                       <div className="ml-7 flex flex-col text-sm opacity-70">
//                         {item.children.map((sub, j) => {
//                           const SubIcon = sub.icon;
//                           const subContent = (
//                             <div className="flex items-center gap-3">
//                               {SubIcon && <SubIcon size={18} />}
//                               {sub.label}
//                             </div>
//                           );
//                           if (sub.onClick) {
//                             return (
//                               <button
//                                 key={j}
//                                 onClick={() => {
//                                   setMobileOpen(false);
//                                   sub.onClick();
//                                 }}
//                                 className="py-1 text-left w-full"
//                               >
//                                 {subContent}
//                               </button>
//                             );
//                           }

//                           return sub.external ? (
//                             <a
//                               key={j}
//                               href={sub.path}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               onClick={() => setMobileOpen(false)}
//                               className="py-1"
//                             >
//                               {subContent}
//                             </a>
//                           ) : (
//                             <Link
//                               key={j}
//                               to={sub.path}
//                               onClick={scrollToContent}
//                               className="py-1"
//                             >
//                               {subContent}
//                             </Link>
//                           )
//                         })}
//                       </div>
//                     </>
//                   )}
//                 </div>
//               );
//             })}
 

 
//             <div className="mt-auto pt-4 border-t border-white/10">
 
 
 
//               <button
//                 onClick={logout}
//                 className="w-full bg-red-500 py-2 rounded"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
 
 
 
 
 
 
 
 
 
 
 
//       {/* ================= NOTIFICATION DRAWER ================= */}
// {/* ================= NOTIFICATION DRAWER ================= */}
 
// <div
//   className={`
//   fixed top-0 right-0 h-full w-[400px] max-w-[95vw]
//   bg-[#2A1D55]/95
//   supports-[backdrop-filter]:bg-white/10
//   backdrop-blur-xl
//   border-l border-white/20
//   shadow-[0_20px_60px_rgba(0,0,0,0.4)]
//   z-[60]
//   transform transition-all duration-500 ease-outout
//     ${notifOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}
//   `}
// >
 
//   {/* HEADER */}
//   <div className="flex justify-between items-center px-5 py-4 border-b border-white/20 backdrop-blur-md bg-[#2A1D55]">
 
//     <span className="text-lg font-semibold text-white tracking-wide ">
//       Notifications
//     </span>
 
//     <button
//       onClick={() => setNotifOpen(false)}
//       className="p-1 rounded-lg text-white/70 hover:text-red-400 hover:bg-white/10 transition"
//     >
//       <X size={20} />
//     </button>
 
//   </div>
 
 
//   {/* CLEAR ALL */}
//   {notifications.length > 0 && (
//     <div className="flex justify-end px-5 mt-2 ">
//       <button
//         onClick={() => useNotificationStore.getState().clearAll()}
//         className="
//           text-xs font-semibold
//           text-red-500 hover:text-red-400
//           transition
//         "
//       >
//         Clear All
//       </button>
//     </div>
//   )}
 
 
//   {/* BODY */}
//   {notifications.length === 0 ? (
//     <div className="flex items-center justify-center h-[70%] text-white/70 text-sm">
//       No notifications
//     </div>
//   ) : (
//     <ul className="overflow-y-auto h-[calc(100%-120px)] p-4 space-y-3">
 
//       {notifications.map((n) => (

      

// //         <li
// //         key={n.id}
// //         className="
// //           relative flex gap-3 p-3
// //           bg-white/10 backdrop-blur-md
// //           border border-white/10
// //           rounded-xl
// //           hover:bg-white/20
// //           transition-all duration-200
// //           shadow-md
// //           group
// //         "
// // >

//         <li
//         key={n.id}
//         className="
//     relative flex gap-3 p-3 bg-[#1e1e2f]/80
//         border border-white/10 rounded-xl hover:bg-[#2a2a40]
//        transition-all duration-200 shadow-md group backdrop-blur-sm
//         "
// >

//         {/* CLOSE BUTTON */}
// <button
//           onClick={(e) => {
//             e.stopPropagation();
//             removeNotification(n.id);
//           }}
//           className="
//             absolute top-2 right-2
//             opacity-0 group-hover:opacity-100
//             transition
//             text-white hover:text-red-400
//           "
// >
// <X size={14} />
// </button>

//         {/* AVATAR */}
// <div className="w-9 h-9 rounded-full overflow-hidden bg-white/20 border border-white/20 shrink-0">


//   <img
//     src={
//       n.sender_profile_pic
//         ? `${IMAGE_BASE_URL}${n.sender_profile_pic}`
//         : n.userdata?.profile_pic
//         ? `${IMAGE_BASE_URL}${n.userdata.profile_pic}`
//         : userIcon
//     }
//     className="w-9 h-9 object-cover"
//     alt="User"
//     onError={(e) => (e.target.src = userIcon)}
//   />
// </div>

// {/* RELATIVE TIME IN TOP RIGHT */}
// <div className="absolute top-1 right-3 text-[8px] font-bold text-white/50 uppercase tracking-wider group-hover:opacity-0 transition-opacity">
//   {getRelativeNotifTime(n.created_at)}
// </div>
// <div
//           className="flex-1 cursor-pointer"
       




//           onClick={() => {
//             removeNotification(n.id);
//             setNotifOpen(false);
          
//             const typeKey = (n.type || "").toUpperCase();
          
//             if (typeKey === "LEAVE") {
//               navigate("/leaves/pending");
          
//             } else if (typeKey === "CHAT") {
//               setChatOpen(true);

//             } else if (typeKey === "LATE PUNCH IN") {
//                 navigate("/attendance/all");

//               } else if (typeKey === "EXTRA BREAK") {
//                 navigate("/attendance/all");
//               } else if (typeKey === "EARLY PUNCH OUT") {
//                 navigate("/attendance/all");


//               } else if (typeKey === "TASK ASSIGNED") {
//                 navigate("/tasks/assigned");
                
//               } else if (typeKey === "GRIEVANCE_UPDATE") {
//                 navigate("/grievance");



//               } else if (typeKey === "TASK COMMENT") {
//                 navigate("/tasks/all");
//               } else if (typeKey === "TASK UPDATED") {
//                 navigate("/tasks/all");
//               } else if (typeKey === "TASK DUE TODAY") {
//                 navigate("/tasks/all");
//               } else if (typeKey === "DUE DATE CHANGED") {
//                 navigate("/tasks/all");






          
//             } else if (
//               typeKey.includes("POST") || 
//               typeKey.includes("FEED")
//             ) {
//               navigate("/", { state: { tab: "posts" } });
          
//             } else {
//               // ✅ MAIN FIX (your requirement)
//               navigate(n.redirectTo || "/");
//             }
//           }}
// >


// <div className="text-sm font-medium text-white leading-snug">
//               {n.message}
//             </div>
 
//             <div className="flex items-center gap-2 mt-1">
 
//               <span className="
//                 text-[10px]
//                 px-2 py-[2px]
//                 rounded-sm shadow-lg
//                 bg-purple-500/30
//                 text-purple-200
//                 font-semibold
//               ">
//                 {n.type.toUpperCase()}
//               </span>
 
//               {n.leaveType && (
//                 <span className="text-[10px] text-white/60">
//                   {n.leaveType}
//                 </span>
//               )}
 




//  <span className="text-[10px] text-white/70 ml-auto mb-[-14px] font-medium">
//                 {formatNotifTime(n.created_at)}
//               </span>

              
//             </div>
 
//           </div>
 
// </li>
//       ))}
//     </ul>
//   )}
 
// </div>
 
// {chatOpen && <ChatDrawer onClose={() => setChatOpen(false)} />}
//       <CreatePayrollInfoModal 
//         isOpen={isPayrollModalOpen} 
//         onClose={() => setIsPayrollModalOpen(false)} 
//         onSuccess={() => window.location.reload()}
//       />
      
//       {/* BACKDROP OVERLAY */}
// {notifOpen && (
//   <div
//     className="
//       fixed inset-0
//       bg-black/50
//       backdrop-blur-sm
//       z-50
//       transition-opacity
//     "
//     onClick={() => setNotifOpen(false)}
//   />
// )}
//     </>
//   );
// }
 








